export const oneMinute = 60 * 1000;
export const threeSeconds = 3000;
